import cn from 'classnames';
import Image from 'next/image';

const ImageContent = ({ image }) => (
  <div
    className={cn('relative mb-6', {
      'overflow-hidden rounded-2xl mb-10': image.borderRadius
    })}
  >
    <Image
      unoptimized
      src={image.url}
      alt={image.alt}
      quality={100}
      width={image.width || '40'}
      height={image.height || '40'}
    />
  </div>
);

export default ImageContent;
